export default "__VITE_ASSET__DdwDKRO5__"